import type {
  AgentTestChangeRowIdentifiers,
  AgentTestConfigPlan,
  AgentTestOperation,
} from '../../../../types';
import { getAgentTestChangeRowId } from '../../../../types';
import type { ToolRendererArgs } from '../../types';

export const isAgentTestOperation = (
  value: unknown,
): value is AgentTestOperation =>
  value === 'update' || value === 'create' || value === 'delete';

export function planFromToolArgs<TChange>(
  toolArgs: ToolRendererArgs,
  toolCallId: string,
): AgentTestConfigPlan<TChange> {
  const changes = Array.isArray(toolArgs?.changes)
    ? (toolArgs.changes as TChange[])
    : [];
  const rawOperation = toolArgs?.operation;
  return {
    toolCallId,
    operation: isAgentTestOperation(rawOperation) ? rawOperation : 'update',
    changes,
    isSelectAll: true,
    excludedItems: [],
    selectedItems: [],
  };
}

export const getApprovedChanges = <
  TChange extends AgentTestChangeRowIdentifiers,
>(
  plan: AgentTestConfigPlan<TChange>,
): TChange[] =>
  plan.isSelectAll
    ? plan.changes.filter(
        (change) =>
          !plan.excludedItems.includes(getAgentTestChangeRowId(change)),
      )
    : plan.changes.filter((change) =>
        plan.selectedItems.includes(getAgentTestChangeRowId(change)),
      );

export function buildNewArgsFromPlan<
  TChange extends AgentTestChangeRowIdentifiers,
>(
  plan: AgentTestConfigPlan<TChange>,
  toolArgs: ToolRendererArgs,
): Record<string, unknown> {
  return {
    goal: String(toolArgs?.goal ?? ''),
    env_id: String(toolArgs?.env_id ?? ''),
    operation: plan.operation,
    changes: getApprovedChanges(plan),
  };
}
